export const en = {
    'hint_search-error': 'Error',
    'hint_search-in-progress': 'Searching...',
    'hint_search-results': 'Documents found: {{count}}',
    'search-author-suggest-no-results': 'No results found for "{{query}}"',
    'search-empty-results': 'No results',
    'search-error': 'Error loading data',
    'search-filters': 'Filters',
    'search-filters-author': 'Page author',
    'search-filters-author-it-is-you': 'you',
    'search-filters-author-me': 'My pages',
    'search-filters-author-suggest-placeholder': 'Enter employee name',
    'search-filters-clear-all': 'Clear all',
    'search-filters-creation-date': 'Creation Date',
    'search-filters-data-range-placeholder': 'Select date',
    'search-filters-date': 'Date',
    'search-filters-date-range-this-month': 'This month',
    'search-filters-date-range-this-week': 'This week',
    'search-filters-date-range-this-year': 'This year',
    'search-filters-date-range-today': 'Today',
    'search-filters-document-type': 'Document type',
    'search-filters-document-type-all': 'All',
    'search-filters-document-type-file': 'File',
    'search-filters-document-type-grid': 'Table',
    'search-filters-document-type-page': 'Page',
    'search-filters-modification-date': 'Modification date',
    'search-filters-section': 'Cluster',
    'search-filters-section-current-page': 'current',
    'search-filters-section-help-tooltip': 'Enter cluster address relative to the Wiki homepage. For example, to search all subpages included in the https://wiki.yandex.ru/my-project/plan cluster, enter my-project/plan.',
    'search-filters-section-input-placeholder': 'Enter page address',
    'search-filters-show-obsolete': 'Show outdated',
    'search-indexing-error-description': 'The search index for your knowledge base is not ready yet. Please try again later.',
    'search-indexing-error-title': 'Preparing search index for wiki-pages',
    'search-placeholder': 'Search',
    'search-result-item-changed': 'Updated',
    'search-results': 'Search results',
    'search-show-more': 'Show more',
    'search-sorting-change-date': 'By date modified',
    'search-sorting-creation-date': 'By date created',
    'search-sorting-relevancy': 'By relevance'
};
